import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/shared/Sidebar';
import { useAuth } from '../../context/AuthContext';
import { FiCalendar, FiClock, FiCheckCircle, FiDollarSign } from 'react-icons/fi';

export default function ShopDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/shop/dashboard').then(r => { setStats(r.data); setLoading(false); })
      .catch(err => {
        if (err.response?.data?.code === 'SUBSCRIPTION_EXPIRED') window.location.href = '/subscription-expired';
        setLoading(false);
      });
  }, []);

  const daysLeft = user?.subscription_end ? Math.ceil((new Date(user.subscription_end) - new Date()) / (1000 * 60 * 60 * 24)) : null;

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        {/* Subscription Warning */}
        {daysLeft !== null && daysLeft <= 7 && daysLeft > 0 && (
          <div className="alert alert-warning" style={{ marginBottom: '20px' }}>
            ⚠️ Aapka subscription <strong>{daysLeft} din</strong> mein expire ho raha hai. Renewal ke liye admin se rabta karein!
          </div>
        )}

        <div className="page-header">
          <h1>Assalamu Alaikum, {user?.name || user?.shop_name}! 👋</h1>
          <p>Aapki shop ka overview — {new Date().toLocaleDateString('ur-PK', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        {loading ? <div className="spinner" style={{ margin: '40px auto' }} /> : stats && (
          <>
            <div className="grid-4" style={{ marginBottom: '28px' }}>
              {[
                { label: "Aaj ki Bookings", value: stats.todayBookings, icon: FiCalendar, color: 'var(--accent)' },
                { label: "Pending Confirm", value: stats.pendingBookings, icon: FiClock, color: 'var(--gold)' },
                { label: "Is Mahine", value: stats.monthBookings, icon: FiCheckCircle, color: 'var(--success)' },
                { label: "Total Earnings", value: `PKR ${Number(stats.totalRevenue).toLocaleString()}`, icon: FiDollarSign, color: '#6c5ce7' },
              ].map((s, i) => (
                <div key={i} className="stat-card" style={{ borderLeft: `4px solid ${s.color}` }}>
                  <div className="flex-between">
                    <div><div className="stat-value" style={{ fontSize: '26px' }}>{s.value}</div><div className="stat-label">{s.label}</div></div>
                    <s.icon size={28} color={s.color} />
                  </div>
                </div>
              ))}
            </div>

            {/* Upcoming Bookings */}
            <div className="card">
              <div className="flex-between mb-4">
                <h3>📅 Upcoming Bookings</h3>
                <Link to="/dashboard/bookings" className="btn btn-outline btn-sm">Sab Dekhein →</Link>
              </div>
              {stats.upcomingBookings?.length > 0 ? (
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th>Customer</th><th>Date</th><th>Time</th><th>Service</th><th>Staff</th><th>Status</th></tr></thead>
                    <tbody>
                      {stats.upcomingBookings.map(b => (
                        <tr key={b.id}>
                          <td>
                            <div style={{ fontWeight: 600 }}>{b.customer_name}</div>
                            <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{b.customer_phone}</div>
                          </td>
                          <td>{new Date(b.booking_date).toLocaleDateString('en-PK')}</td>
                          <td>{b.booking_time?.slice(0, 5)}</td>
                          <td>{b.service_name || '—'}</td>
                          <td>{b.staff_name || '—'}</td>
                          <td><span className={`badge ${b.status === 'confirmed' ? 'badge-success' : 'badge-warning'}`}>{b.status}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : <p style={{ color: 'var(--text-light)', textAlign: 'center', padding: '32px' }}>Koi upcoming booking nahi hai</p>}
            </div>

            {/* Quick Actions */}
            <div className="card mt-4">
              <h3 style={{ marginBottom: '16px' }}>⚡ Quick Actions</h3>
              <div className="flex gap-3" style={{ flexWrap: 'wrap' }}>
                <Link to="/dashboard/bookings" className="btn btn-primary">+ Nai Booking Add</Link>
                <Link to="/dashboard/services" className="btn btn-secondary">✂️ Services Manage</Link>
                <Link to="/dashboard/staff" className="btn btn-outline">👤 Staff Manage</Link>
                <a href={`/shop/${user?.slug}`} target="_blank" rel="noreferrer" className="btn btn-gold">🌐 My Shop Page Dekhein</a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
